module.exports = __webpack_public_path__ + "img/home-v2-5.f75c35c6.jpg";